<template>
    <div class="flex">
        <input
            type="radio"
            :id="option.value"
            :name="name"
            :value="value"
            :checked="value == option.value"
            @input="$emit('input', option.value)"
            @change="$emit('setTouched')"
        />
        <label :for="option.value">
            {{ option.name }}
        </label>
    </div>
</template>

<script>
export default {
    name: 'InputRadio',
    props: ['option', 'name', 'value'],
}
</script>

<style scoped>
.flex {
    display: flex;
}

label {
    display: block;
    text-align: center;
    border: 2px solid #E6E7E8;
    border-radius: 20px;
    padding: 1rem 2rem;
    cursor: pointer;
    width: 100%;
    margin-bottom: 1rem;
    font-size: 14px;
    color: #424244;
    transition: all 0.2s ease;
}

label:hover {
    background: var(--c-light-grey);
    border-color: var(--c-link);
}

label:active {
    background: #fff;
    border-color: var(--c-link);
}

@media (min-width: 900px) {
    label {
        font-size: 20px;
        border-radius: 30px;
    }
}

input {
    display: none;
}

input:checked + label {
    background: #fff;
    border-color: var(--c-red);
    color: var(--c-red);
}
</style>
